import React from 'react';
import { makeStyles } from '@material-ui/core';
import RowDivider, { RowDividerProps } from '../RowDivider';
import { LoadingWrapper } from '../Loading';

const loadingWrapperProps = { minHeight: 40 };

interface StyleProps {
  fullHeight?: boolean;
  moreInfo?: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: (props: StyleProps) => (props.fullHeight ? '100%' : 'auto'),
  },
  descriptionContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: (props: StyleProps) =>
      props.moreInfo ? 'space-between' : 'flex-start',
  },
}));

interface PageRowProps extends StyleProps {
  description?: React.ReactNode;
  children?: React.ReactNode;
  hideDivider?: boolean;
  dividerProps?: RowDividerProps;
  isLoading?: boolean;
}

export const SettingsPageRow: React.FC<PageRowProps> = ({
  description,
  children,
  hideDivider = false,
  moreInfo,
  fullHeight = false,
  dividerProps = {},
  isLoading = false,
}) => {
  const classes = useStyles({ fullHeight, moreInfo });

  return (
    <div className={classes.root}>
      {description && (
        <div className={classes.descriptionContainer}>
          {description}
          {moreInfo}
        </div>
      )}
      {!hideDivider && <RowDivider {...dividerProps} />}
      <LoadingWrapper
        isLoading={isLoading}
        wrapperProps={loadingWrapperProps}
        hideContentWhileLoading
      >
        {children}
      </LoadingWrapper>
    </div>
  );
};
